import * as Haptics from 'expo-haptics'

/**
 * One light tap confirming a long press (e.g. opening a chat message's
 * reaction tray).
 *
 * expo-haptics covers every platform: the system impact generator on iOS and
 * Android, and on web the Vibration API (Android browsers) or, on iOS Safari
 * 18+, the system haptic of a hidden switch toggle. Browsers without either
 * simply stay silent.
 */
export function longPressHaptic(impact: typeof Haptics.impactAsync = Haptics.impactAsync): void {
  // A missing or blocked haptic is not worth reporting: the press still works,
  // it just has no tactile confirmation.
  impact(Haptics.ImpactFeedbackStyle.Light).catch(() => {})
}
